import { createActionTypes } from '../../../../util/createActionsHelpers';

export const GET_USER_SAVED_ARTICLES = createActionTypes(
  'GET_USER_SAVED_ARTICLES'
);
